import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';

export default [
  {
    path: '/IFPageNinetySixPreLogin',
    name: 'IFPageNinetySixPreLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageNinetySix/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (from.path === '/IFPageNinetySixLogin' || from.path === '/IFPageNinetySixLoginSecond') {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageNinetySixLogin',
    name: 'pageNinetySixLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageNinetySix/login.vue'),
  },
  {
    path: '/IFPageNinetySixLeaveInfo',
    name: 'pageNinetySixLeaveInfo',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageNinetySix/leaveInfo.vue'),
  },
  {
    path: '/IFPageNinetySixResult',
    name: 'pageNinetySixResult',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageNinetySix/result.vue'),
  },
  {
    path: '/IFPageNinetySixLoading',
    name: 'pageNinetySixLoading',
    component: () => import('@/pages/pageListAll/pageNinetySix/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageNinetySixLoginSecond',
    name: 'pageNinetySixLoginSecond',
    component: () => import('@/pages/pageListAll/pageNinetySix/loginSecond.vue'),
    meta: {
      title: '星贷',
    },
  },
  {
    path: '/IFPageNinetySixOnline',
    name: 'pageNinetySixOnline',
    component: () => import('@/pages/pageListAll/pageNinetySix/online.vue'),
    meta: {
      title: '星贷',
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageNinetySixLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageNinetySixGuide',
    name: 'pageNinetySixLoginGuide',
    component: () => import('@/pages/pageListAll/pageNinetySix/guide.vue'),
    meta: {
      title: '星贷',
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageNinetySixCar',
    name: 'pageNinetySixCar',
    component: () => import('@/pages/pageListAll/pageNinetySix/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageNinetySixCarDetails',
    name: 'pageNinetySixCarDetails',
    component: () => import('@/pages/pageListAll/pageNinetySix/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },
  {
    path: '/IFPageNinetySixBlank',
    name: 'pageNinetySixBlank',
    component: () => import('@/pages/pageListAll/pageNinetySix/blank.vue'),
    meta: {
      title: '星贷',
    },
  },
  {
    path: '/IFPageNinetySixOnlineTab',
    name: 'pageNinetySixOnlineTab',
    component: () => import('@/pages/pageListAll/pageNinetySix/onlineTab.vue'),
    meta: {
      title: '星贷',
    },
  },
];
